var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "xui-icon",
    focusable: "false",
    height: 12,
    role: "presentation",
    viewBox: "0 0 12 12",
    width: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.75L7 6.5 5.5 5l3.75-3.75L8 0h4v4l-1.25-1.25zM6 0v1H1v10h10V6h1v4.91c0 .545-.5 1.09-1 1.09H1c-.5 0-1-.545-1-1.09l.01-9.82C0 .546.5 0 1 0h5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.a55bbd77884f9ff384cf8dd937a770dd.svg";
export { ForwardRef as ReactComponent };